import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    courses: {},
    currentStep: 0,
    coursesCount: 0,
    userExist: 0,
    first_name: "",
    last_name: "",
    Dregion:"",
    phone_number: "",
    email: "",
    globalURL:"",
    selected: "",
    Dlanguage:"English",
    country: "",
    countryvalid: false,
    userStatus: "",
    signInUrls: {
      br: 'https://courses.starbucksglobalacademy.com',
      ca: 'https://courses-canada.starbucksglobalacademy.com',
      in: 'https://courses.starbucksglobalacademy.com',
      pr: 'https://courses-pr.starbucksglobalacademy.com',
      uk: 'https://courses.starbucksglobalacademy.com',
      us: 'https://courses.starbucksglobalacademy.com'
    }
  },
  getters: {},
  mutations: {
    changeStep(state, value) {
      state.currentStep = value;
    }
  },
  actions: {}
});
